module.exports = __webpack_public_path__ + "static/media/Valparaiso.80053fa6.png";